module.exports = __webpack_public_path__ + "static/media/FormIcon.0491d9ac.svg";